// src/pages/AddStock.jsx

import { useState, useEffect } from "react";
import axios from '../../axios';
import API_BASE_URL from "../../config";
import { useNavigate } from "react-router-dom";
import { Switch } from "../../components/ui/switch";

export default function AddStock() {
  const navigate = useNavigate();
  const companyId = parseInt(localStorage.getItem("companyId"), 10);

  const [formData, setFormData] = useState({
    name: "",
    manager: "",
    notes: "",
    branchId: "",
    isActive: true,
  });
  const [branches, setBranches] = useState([]);
  const [stocks, setStocks]     = useState([]);
  const [loading, setLoading]   = useState(false);

  // جلب الفروع والمستودعات عند التحميل
  useEffect(() => {
    if (!companyId) return;

    axios
      .get(`${API_BASE_URL}/Branch/by-company/${companyId}`)
      .then(res => {
        setBranches(res.data);
        if (res.data.length > 0) {
          setFormData(f => ({ ...f, branchId: res.data[0].id }));
        }
      })
      .catch(err => console.error("❌ خطأ في تحميل الفروع:", err));

    fetchStocks();
  }, [companyId]);

  const fetchStocks = async () => {
    try {
      const res = await axios.get(
        `${API_BASE_URL}/Stock/by-company/${companyId}`
      );
      setStocks(res.data);
    } catch (err) {
      console.error("❌ خطأ تحميل المستودعات:", err);
    }
  };

  const handleChange = e => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API_BASE_URL}/Stock`, {
        ...formData,
        companyId,
        branchId: parseInt(formData.branchId, 10),
      });
      alert("✅ تم إضافة المستودع بنجاح");
      setFormData({ name: "", manager: "", notes: "", branchId: branches[0]?.id || "", isActive: true });
      fetchStocks();
    } catch (err) {
      console.error("❌ حدث خطأ أثناء الحفظ:", err.response?.data || err);
      alert(err.response?.data?.message || "❌ حدث خطأ أثناء الحفظ");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async id => {
    if (!window.confirm("❗ هل تريد حذف (تعطيل) هذا المستودع؟")) return;
    try {
      await axios.delete(`${API_BASE_URL}/Stock/${id}`);
      fetchStocks();
    } catch (err) {
      console.error("❌ خطأ عند الحذف:", err);
      alert("❌ حدث خطأ أثناء الحذف");
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 p-4" dir="rtl">
      <div className="max-w-4xl mx-auto space-y-6">
        {/* --- نموذج إضافة مستودع --- */}
        <form
          onSubmit={handleSubmit}
          className="bg-white p-6 rounded-lg shadow-lg space-y-6"
        >
          <h2 className="text-2xl font-bold text-blue-700 text-center">
            📦 إضافة مستودع
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm mb-1">اسم المستودع</label>
              <input
                name="name"
                value={formData.name}
                onChange={handleChange}
                className="w-full border border-gray-300 rounded px-3 py-2"
                required
              />
            </div>

            <div>
              <label className="block text-sm mb-1">اسم المسؤول</label>
              <input
                name="manager"
                value={formData.manager}
                onChange={handleChange}
                className="w-full border border-gray-300 rounded px-3 py-2"
                required
              />
            </div>

            <div>
              <label className="block text-sm mb-1">الفرع</label>
              <select
                name="branchId"
                value={formData.branchId}
                onChange={handleChange}
                className="w-full border border-gray-300 rounded px-3 py-2"
                required
              >
                <option value="">اختر فرع</option>
                {branches.map(b => (
                  <option key={b.id} value={b.id}>{b.name}</option>
                ))}
              </select>
            </div>

            <div>
              <label className="block text-sm mb-1">ملاحظات</label>
              <input
                name="notes"
                value={formData.notes}
                onChange={handleChange}
                className="w-full border border-gray-300 rounded px-3 py-2"
              />
            </div>
          </div>

          <div className="flex items-center gap-2">
            <Switch
              id="isActive-switch"
              name="isActive"
              checked={formData.isActive}
              onChange={handleChange}
            />
            <label htmlFor="isActive-switch" className="text-sm font-medium cursor-pointer">
              تفعيل المستودع
            </label>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2 rounded text-lg disabled:opacity-50"
          >
            {loading ? "جاري الحفظ..." : "💾 حفظ"}
          </button>
        </form>

        {/* --- جدول المستودعات --- */}
        <div className="bg-white p-4 rounded-lg shadow-lg overflow-x-auto">
          <h3 className="text-xl font-semibold mb-4">📋 قائمة المستودعات</h3>
          <table className="min-w-full table-auto border-collapse text-sm">
            <thead>
              <tr className="bg-gray-100 text-center">
                {["#", "الاسم", "المسؤول", "الفرع", "الملاحظات", "نشط", "إجراءات"].map((h, i) => (
                  <th key={i} className="px-4 py-2 border">{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {stocks.map((s, idx) => (
                <tr key={s.id} className={idx % 2 === 0 ? "bg-white" : "bg-gray-50"}>
                  <td className="px-4 py-2 border text-center">{idx + 1}</td>
                  <td className="px-4 py-2 border">{s.name}</td>
                  <td className="px-4 py-2 border">{s.manager}</td>
                  <td className="px-4 py-2 border text-center">{s.branchName || "-"}</td>
                  <td className="px-4 py-2 border">{s.notes || "-"}</td>
                  <td className="px-4 py-2 border text-center">{s.isActive ? "نعم" : "لا"}</td>
                  <td className="px-4 py-2 border text-center space-x-2">
                    <button
                      onClick={() => navigate(`/edit-stock/${s.id}`)}
                      className="px-2 py-1 bg-yellow-500 hover:bg-yellow-600 text-white rounded"
                    >
                      ✏️
                    </button>
                    <button
                      onClick={() => handleDelete(s.id)}
                      className="px-2 py-1 bg-red-600 hover:bg-red-700 text-white rounded"
                    >
                      🗑️
                    </button>
                  </td>
                </tr>
              ))}
              {stocks.length === 0 && (
                <tr>
                  <td colSpan="7" className="px-4 py-6 border text-center text-gray-500">
                    لا يوجد مستودعات
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
